import { render, staticRenderFns } from "./CollegeSearch.vue?vue&type=template&id=10fe6304&scoped=true&"
import script from "./CollegeSearch.vue?vue&type=script&lang=js&"
export * from "./CollegeSearch.vue?vue&type=script&lang=js&"
import style0 from "./CollegeSearch.vue?vue&type=style&index=0&id=10fe6304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe6304",
  null
  
)

export default component.exports